export const enum UserRole {
  ADMIN = 'admin',
  CONTENT_MANAGER = 'contentManager',
}
